module.exports = __webpack_public_path__ + "static/media/top-up-img-small.aeb65143.svg";